import React, { useEffect, useMemo, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Formik } from 'formik';
import * as yup from 'yup';
import ArrowLeft from 'assets/icons/ic-arrow-left.svg';
import './Assessment.scss';
import { Tab, Tabs } from 'react-bootstrap';
import { TabContent } from 'components/common/TabContent';
import { getAssessment } from 'store/assessmentSingle/actions';
import { useDispatch, useSelector } from 'react-redux';
import { IAppState } from 'store';
import { IAssessmentSingleState } from 'store/assessmentSingle/types';
import { configureValidation, DISABLED_ASSESSMENT_STATUS_FLAG } from './config';
import TableLoader from 'components/TableLoader';
import { CompleteAssessment } from 'components/CompleteAssessment';
import { SaveAssessmentModal } from '../../components/SaveAssessmentModal';
import { ROUTES } from '../../config/routes';
import { getApiAssessment } from '../../store/assessment/actions';
import { useTranslation } from 'react-i18next';
import { translateText } from 'utils/helpers/useTranslation';
import { CONDITIONS } from 'utils/helpers/enum';
import { checkAllConditionsFollow } from 'utils/helpers/useCondition';

interface IInitialValues {
  [key: string]: string | object;
}

interface IValidationScheme {
  [key: string]: any;
}

const Assessment = () => {
  const { uid } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const [exitModalOpen, setExitModalOpen] = useState(false);
  const [isHaveErrors, SetIsHaveErrors] = useState(false);
  const { t } = useTranslation();

  const { data, isLoading, error } = useSelector<
    IAppState,
    IAssessmentSingleState
  >(state => state.singleAssessment);
  const [newData, setNewData] = useState(data);
  const [key, setKey] = useState('');

  const [initialValues, validSchema] = useMemo(() => {
    const initial: IInitialValues = {};
    const validation: IValidationScheme = {};
    data.forEach(ass => {
      ass?.Pages.forEach(page => {
        page.Fields.forEach(field => {
          if (field.Template.FieldType.Name === 'Grid') {
            const arrayOfFields = [];
            field.GridChildren.forEach(fieldArray => {
              const fieldsObject = {};
              fieldArray.forEach(f => {
                fieldsObject[f.Template.Name] = f.Value;
              });
              arrayOfFields.push(fieldsObject);
            });
            initial[field.Guid] = arrayOfFields;
          } else {
            initial[field.Guid] = field.Value || '';
            validation[field.Guid] = configureValidation(
              field.Template.Validator.Discriminator || undefined,
              field.Template.Required,
            );
          }
        });
      });
    });
    const vScheme = yup.object().shape({ ...validation });
    return [initial, vScheme];
  }, [data]);

  useEffect(() => {
    dispatch(getAssessment(uid));
  }, [dispatch, uid]);

  useEffect(() => {
    setNewData(data);
  }, [dispatch, data, key]);

  useEffect(() => {}, [newData, data]);

  const onGoBack = (isFormTouched: any) => {
    if (data?.[0]?.StatusFlag === 2 || data?.[0]?.StatusFlag === 5) {
      history.goBack();
      return null;
    }
    if (!!Object.keys(isFormTouched).length) {
      setExitModalOpen(true);
    } else {
      history.goBack();
    }
  };

  const onModalAgree = async () => {
    await dispatch(getApiAssessment());
    setExitModalOpen(false);
    history.goBack();
  };

  const onModalCancel = () => {
    setExitModalOpen(false);
  };

  const haveErrorsHandler = () => {
    SetIsHaveErrors(true);
  };

  console.log(error);

  return (
    <>
      <div className="page-content">
        <div
          className={
            isHaveErrors
              ? 'container-custom container assessment-container invalid'
              : 'container-custom container assessment-container'
          }
        >
          <div className="row">
            <div className="col-12">
              {isLoading ? (
                <TableLoader />
              ) : error ? (
                <p>sorry we have some troubles, reload the page please</p>
              ) : (
                <>
                  <Formik
                    initialValues={initialValues}
                    validationSchema={validSchema}
                    // validateOnChange={false}
                    // validateOnBlur={false}
                    onSubmit={null}
                  >
                    {formik => (
                      <form onSubmit={formik.handleSubmit}>
                        <div className="assessment-header">
                          <h2 className="assessment-name">
                            <button
                              className="assessment-back"
                              onClick={onGoBack.bind(null, formik.touched)}
                            >
                              <img src={ArrowLeft} alt="arrow image" />
                            </button>
                            {data.length > 0 && data[0].Template.Name}
                          </h2>
                          <div className="assessment-buttons">
                            {/* <CompleteAssessment
                              assessmentsId={data?.map(ass => ass.ID)}
                              isHaveErrors={haveErrorsHandler}
                            /> */}
                          </div>
                        </div>

                        <div className="tabs-wrapper">
                          {data?.length > 1 ? (
                            <Tabs
                              defaultActiveKey="first"
                              className="nav nav-tabs primary-tabs"
                            >
                              {data?.map(
                                ass =>
                                  ass.Template.TemplatePageType == 0 && (
                                    <Tab
                                      className="nav-item nav-link"
                                      title={translateText(
                                        ass.Template.Name,
                                        data,
                                      )}
                                      eventKey={ass.Template.Name}
                                      key={ass.ID}
                                    >
                                      <div className="inner-tabs-wrapper">
                                        <Tabs className="nav nav-tabs">
                                          {ass?.Pages.map((p, i) => (
                                            <Tab
                                              className="nav-item nav-link"
                                              title={p.Template.Name}
                                              eventKey={p.Template.Name}
                                              key={p.ID}
                                            >
                                              <TabContent
                                                translations={
                                                  data?.[0]?.Template
                                                    .Translations
                                                }
                                                data={p}
                                                fieldsDisabled={
                                                  ass.StatusFlag ===
                                                  DISABLED_ASSESSMENT_STATUS_FLAG
                                                }
                                                pageNum={i}
                                                assId={ass.ID}
                                              >
                                                <CompleteAssessment
                                                  assessmentsId={data?.[0].ID}
                                                  isHaveErrors={
                                                    haveErrorsHandler
                                                  }
                                                  dataP={p}
                                                />
                                              </TabContent>
                                            </Tab>
                                          ))}
                                        </Tabs>
                                      </div>
                                    </Tab>
                                  ),
                              )}
                            </Tabs>
                          ) : (
                            <Tabs
                              className="nav nav-tabs"
                              defaultActiveKey={
                                data?.[0]?.Pages[0].Template.Name
                              }
                              // activeKey={key}
                              onSelect={k => setKey(k)}
                            >
                              {data?.[0]?.Pages.map((p, i) => {
                                const noDisplayConditions =
                                  p.Template.DisplayConditions.length < 1 ||
                                  p.Template.DisplayConditions === undefined ||
                                  p.Template.DisplayConditions === null;
                                const conditionToShow =
                                  noDisplayConditions ||
                                  (!noDisplayConditions &&
                                    checkAllConditionsFollow(p, newData));
                                if (p.Template.TemplatePageType !== 0) {
                                  if (conditionToShow) {
                                    return (
                                      <Tab
                                        className="nav-item nav-link"
                                        title={translateText(
                                          p.Template.Name,
                                          data,
                                        )}
                                        eventKey={p.Template.Name}
                                        key={p.ID}
                                      >
                                        <TabContent
                                          translations={
                                            data?.[0]?.Template.Translations
                                          }
                                          data={p}
                                          newData={newData}
                                          setNewData={setNewData}
                                          fieldsDisabled={
                                            data?.[0].StatusFlag ===
                                            DISABLED_ASSESSMENT_STATUS_FLAG
                                          }
                                          pageNum={i}
                                          assId={data?.[0].ID}
                                        >
                                          <CompleteAssessment
                                            assessmentsId={data?.[0].ID}
                                            isHaveErrors={haveErrorsHandler}
                                            dataP={p}
                                          />
                                        </TabContent>
                                      </Tab>
                                    );
                                  }
                                }
                              })}
                            </Tabs>
                          )}
                        </div>
                      </form>
                    )}
                  </Formik>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <SaveAssessmentModal
        onSave={onModalAgree}
        onExit={onModalCancel}
        isOpen={exitModalOpen}
        text={t('AP_sav?')}
        primaryButtonText={t('AP_agree')}
        cancelButtonText={t('AP_cancel')}
      />
    </>
  );
};

export { Assessment };
